import Vue from "vue";
import Vuex from "vuex";
import identity from "@/store/identity";
import identityGetters from "@/store/identity/getters";
import identityActions from "@/store/identity/actions";
import identityMutations from "@/store/identity/mutations";
import notifications from "@/store/notifications";
import notificationsGetters from "@/store/notifications/getters";
import notificationsActions from "@/store/notifications/actions";
import notificationsMutations from "@/store/notifications/mutations";
import screening from "@/store/screening";
import screeningGetters from "@/store/screening/getters";
import screeningActions from "@/store/screening/actions";
import screeningMutations from "@/store/screening/mutations";
import work from "@/store/work";
import workGetters from "@/store/work/getters";
import workActions from "@/store/work/actions";
import workMutations from "@/store/work/mutations";
import complianceReviews from "@/store/complianceReviews";
import complianceReviewsGetters from "@/store/complianceReviews/getters";
import complianceReviewsActions from "@/store/complianceReviews/actions";
import complianceReviewsMutations from "@/store/complianceReviews/mutations";
import stats from "@/store/stats";
import statsGetters from "@/store/stats/getters";
import statsActions from "@/store/stats/actions";
import statsMutations from "@/store/stats/mutations";

function createProxy(target, getError) {
  return new Proxy(target, {
    get(target, key) {
      if (!target[key]) {
        throw getError(key);
      }
      return key;
    }
  });
}

export const actions = createProxy(
  {
    ...identityActions,
    ...workActions,
    ...statsActions,
    ...notificationsActions,
    ...screeningActions,
    ...complianceReviewsActions
  },
  key => `Action key ${key} not exist.`
);

export const getters = createProxy(
  {
    ...identityGetters,
    ...workGetters,
    ...statsGetters,
    ...notificationsGetters,
    ...screeningGetters,
    ...complianceReviewsGetters
  },
  key => `Getter key ${key} not exist.`
);

export const mutations = createProxy(
  {
    ...identityMutations,
    ...workMutations,
    ...statsMutations,
    ...notificationsMutations,
    ...screeningMutations,
    ...complianceReviewsMutations
  },
  key => `Mutation key ${key} not exist.`
);

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    identity,
    notifications,
    work,
    stats,
    screening,
    complianceReviews
  }
});
